import {WpProvider} from "./wp-provider.model";
import {PageResponse} from "./page.model";

export class ProviderSummary{
  constructor(
    public wpProvider?: WpProvider,
    public page?: PageResponse,
    public pageNumber?: number,
    public pageSize?: number,
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/provider-summary.model.ts